import { create } from 'zustand';

type State = {
  filterByName: string;
  filterByCategory: string;
  filterByVisibility: string;
};

type Actions = {
  setFilterByName: (name: string) => void;
  setFilterByCategory: (category: string) => void;
  setFilterByVisibility: (visibility: string) => void;
  resetFilters: () => void;
};

export const useParametersFiltersStore = create<State & Actions>()((set) => ({
  filterByName: '',
  filterByCategory: 'None',
  filterByVisibility: 'None',
  setFilterByName: (name: string) => set({ filterByName: name }),
  setFilterByCategory: (category: string) => set({ filterByCategory: category }),
  setFilterByVisibility: (visibility: string) => set({ filterByVisibility: visibility }),
  resetFilters: () => set({ filterByName: '', filterByCategory: 'None', filterByVisibility: 'None' }),
}));
